
import WkLocationPointDialog from '../WkLocationPointDialog';

import { isObject } from '@/utils/types';
import { valueEquals } from 'element-ui/lib/utils/util';
import Emitter from 'element-ui/lib/mixins/emitter';

export default {
  // 定位
  name: 'WkLocation',

  components: {
    WkLocationPointDialog: WkLocationPointDialog
  },

  mixins: [Emitter],

  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    disabled: Boolean
  },

  data: function data() {
    return {
      hovering: false,
      dataValue: this.getDefaultValue(),
      pointDialogVisible: false
    };
  },


  computed: {},

  watch: {
    value: {
      handler: function handler(val) {
        if (!valueEquals(val, this.dataValue)) {
          if (isObject(this.value)) {
            this.dataValue = val;
          } else {
            this.dataValue = this.getDefaultValue();
            this.$emit('input', this.dataValue);
          }
        }
      },

      immediate: true
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    getDefaultValue: function getDefaultValue() {
      return {
        lat: '',
        lng: '',
        address: ''
      };
    },
    inputClick: function inputClick() {
      if (!this.disabled) {
        this.pointDialogVisible = true;
      }
    },
    inputClear: function inputClear() {
      this.dataValue = this.getDefaultValue();
      this.valueChange();
    },
    pointSelect: function pointSelect(data) {
      if (data) {
        this.dataValue = {
          lat: data.point.lat,
          lng: data.point.lng,
          address: data.address + data.title
        };
      }

      this.valueChange();
    },
    valueChange: function valueChange() {
      this.$emit('input', this.dataValue);
      this.$emit('change', this.dataValue);
      this.dispatch('ElFormItem', 'el.form.change', this.dataValue);
    }
  }
};